// ======================================
// Cost Estimator Page Module
// ======================================

import { icons } from '../components.js';
import { estimatorPricing } from '../data.js';

// Estimator state
let estimatorState = {
  step: 1,
  bhk: null,
  rooms: [],
  finish: null
};

export function renderEstimatorPage() {
  // Reset state when page loads
  estimatorState = { step: 1, bhk: null, rooms: [], finish: null };

  return `
    <section class="section estimator-section">
      <div class="container">
        <div class="estimator-container">
          <div class="estimator-card">
            <div class="estimator-progress">
              <div class="progress-step active" data-step="1">
                <div class="progress-dot">1</div>
                <span class="progress-label">Home Type</span>
              </div>
              <div class="progress-step" data-step="2">
                <div class="progress-dot">2</div>
                <span class="progress-label">Rooms</span>
              </div>
              <div class="progress-step" data-step="3">
                <div class="progress-dot">3</div>
                <span class="progress-label">Finish</span>
              </div>
              <div class="progress-step" data-step="4">
                <div class="progress-dot">4</div>
                <span class="progress-label">Estimate</span>
              </div>
            </div>
            
            <div class="estimator-body">
              <!-- Step 1: BHK Selection -->
              <div class="estimator-step active" id="step-1">
                <h2 class="estimator-question">What type of home do you have?</h2>
                <div class="bhk-options">
                  <div class="bhk-option" data-bhk="1bhk">
                    <div class="bhk-option-icon">🏠</div>
                    <div class="bhk-option-label">1 BHK</div>
                  </div>
                  <div class="bhk-option" data-bhk="2bhk">
                    <div class="bhk-option-icon">🏡</div>
                    <div class="bhk-option-label">2 BHK</div>
                  </div>
                  <div class="bhk-option" data-bhk="3bhk">
                    <div class="bhk-option-icon">🏘️</div>
                    <div class="bhk-option-label">3 BHK</div>
                  </div>
                  <div class="bhk-option" data-bhk="4bhk">
                    <div class="bhk-option-icon">🏰</div>
                    <div class="bhk-option-label">4+ BHK</div>
                  </div>
                </div>
                <div class="estimator-nav">
                  <div></div>
                  <button class="btn btn-primary estimator-next" disabled>
                    Next ${icons.arrowRight}
                  </button>
                </div>
              </div>
              
              <!-- Step 2: Room Selection -->
              <div class="estimator-step" id="step-2">
                <h2 class="estimator-question">What do you want to design?</h2>
                <div class="room-options">
                  <div class="room-option" data-room="kitchen">
                    <div class="room-checkbox">${icons.check}</div>
                    <div class="room-label">Modular Kitchen</div>
                  </div>
                  <div class="room-option" data-room="wardrobe">
                    <div class="room-checkbox">${icons.check}</div>
                    <div class="room-label">Wardrobe</div>
                  </div>
                  <div class="room-option" data-room="tvUnit">
                    <div class="room-checkbox">${icons.check}</div>
                    <div class="room-label">TV Unit</div>
                  </div>
                  <div class="room-option" data-room="falseCeiling">
                    <div class="room-checkbox">${icons.check}</div>
                    <div class="room-label">False Ceiling</div>
                  </div>
                  <div class="room-option" data-room="painting">
                    <div class="room-checkbox">${icons.check}</div>
                    <div class="room-label">Painting</div>
                  </div>
                  <div class="room-option" data-room="studyTable">
                    <div class="room-checkbox">${icons.check}</div>
                    <div class="room-label">Study Table</div>
                  </div>
                </div>
                <div class="estimator-nav">
                  <button class="estimator-back">
                    ${icons.arrowLeft} Back
                  </button>
                  <button class="btn btn-primary estimator-next" disabled>
                    Next ${icons.arrowRight}
                  </button>
                </div>
              </div>
              
              <!-- Step 3: Finish Selection -->
              <div class="estimator-step" id="step-3">
                <h2 class="estimator-question">Choose your finish level</h2>
                <div class="finish-options">
                  <div class="finish-option" data-finish="essential">
                    <div class="finish-name">Essential</div>
                    <div class="finish-desc">Quality materials with standard finishes</div>
                    <div class="finish-price">Budget-friendly</div>
                  </div>
                  <div class="finish-option" data-finish="premium">
                    <div class="finish-name">Premium</div>
                    <div class="finish-desc">Premium hardware with upgraded finishes</div>
                    <div class="finish-price">Best value</div>
                  </div>
                  <div class="finish-option" data-finish="luxe">
                    <div class="finish-name">Luxe</div>
                    <div class="finish-desc">Top-tier materials with luxury finishes</div>
                    <div class="finish-price">Premium quality</div>
                  </div>
                </div>
                <div class="estimator-nav">
                  <button class="estimator-back">
                    ${icons.arrowLeft} Back
                  </button>
                  <button class="btn btn-primary estimator-next" disabled>
                    See Estimate ${icons.arrowRight}
                  </button>
                </div>
              </div>
              
              <!-- Step 4: Result -->
              <div class="estimator-step" id="step-4">
                <div class="estimate-result">
                  <div class="estimate-icon">${icons.calculator}</div>
                  <div class="estimate-label">Estimated Budget Range</div>
                  <div class="estimate-range" id="estimate-range">₹5.5L - ₹7.5L</div>
                  <div class="estimate-summary" id="estimate-summary">
                    <!-- Will be populated dynamically -->
                  </div>
                  <p class="estimate-disclaimer">
                    *This is an estimate. Final quote may vary based on actual measurements and specific requirements.
                  </p>
                  <button class="btn btn-primary btn-lg" data-open-modal="lead-modal">
                    Get Detailed Quote
                  </button>
                  <div style="margin-top: var(--space-4);">
                    <button class="estimator-back" style="margin: 0 auto;">
                      ${icons.arrowLeft} Modify Selections
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `;
}

// Initialize estimator interactions
export function initEstimator() {
  // BHK selection
  document.querySelectorAll('.bhk-option').forEach(option => {
    option.addEventListener('click', () => {
      document.querySelectorAll('.bhk-option').forEach(o => o.classList.remove('selected'));
      option.classList.add('selected');
      estimatorState.bhk = option.dataset.bhk;
      document.querySelector('#step-1 .estimator-next').disabled = false;
    });
  });

  // Room selection
  document.querySelectorAll('.room-option').forEach(option => {
    option.addEventListener('click', () => {
      option.classList.toggle('selected');
      const room = option.dataset.room;
      if (estimatorState.rooms.includes(room)) {
        estimatorState.rooms = estimatorState.rooms.filter(r => r !== room);
      } else {
        estimatorState.rooms.push(room);
      }
      document.querySelector('#step-2 .estimator-next').disabled = estimatorState.rooms.length === 0;
    });
  });

  // Finish selection
  document.querySelectorAll('.finish-option').forEach(option => {
    option.addEventListener('click', () => {
      document.querySelectorAll('.finish-option').forEach(o => o.classList.remove('selected'));
      option.classList.add('selected');
      estimatorState.finish = option.dataset.finish;
      document.querySelector('#step-3 .estimator-next').disabled = false;
    });
  });

  // Navigation
  document.querySelectorAll('.estimator-next').forEach(btn => {
    btn.addEventListener('click', () => {
      if (estimatorState.step < 4) {
        goToStep(estimatorState.step + 1);
      }
    });
  });

  document.querySelectorAll('.estimator-back').forEach(btn => {
    btn.addEventListener('click', () => {
      if (estimatorState.step > 1) {
        goToStep(estimatorState.step - 1);
      }
    });
  });
}

function goToStep(step) {
  // Hide current step
  document.querySelector(`#step-${estimatorState.step}`).classList.remove('active');
  document.querySelector(`.progress-step[data-step="${estimatorState.step}"]`).classList.remove('active');
  document.querySelector(`.progress-step[data-step="${estimatorState.step}"]`).classList.add('completed');

  // Show new step
  estimatorState.step = step;
  document.querySelector(`#step-${step}`).classList.add('active');
  document.querySelector(`.progress-step[data-step="${step}"]`).classList.add('active');

  // Update progress
  for (let i = 1; i < step; i++) {
    document.querySelector(`.progress-step[data-step="${i}"]`).classList.add('completed');
  }
  for (let i = step; i <= 4; i++) {
    if (i !== step) {
      document.querySelector(`.progress-step[data-step="${i}"]`).classList.remove('completed');
      document.querySelector(`.progress-step[data-step="${i}"]`).classList.remove('active');
    }
  }

  // Calculate estimate on step 4
  if (step === 4) {
    calculateEstimate();
  }
}

function calculateEstimate() {
  const { bhk, rooms, finish } = estimatorState;

  // Calculate base price
  let basePrice = 0;
  rooms.forEach(room => {
    if (estimatorPricing.rooms[room]) {
      basePrice += estimatorPricing.rooms[room].base;
    }
  });

  // Apply multipliers
  const bhkMultiplier = estimatorPricing.bhkMultiplier[bhk] || 1;
  const finishMultiplier = estimatorPricing.finishMultiplier[finish] || 1;

  const minPrice = Math.round(basePrice * bhkMultiplier * finishMultiplier * 0.9);
  const maxPrice = Math.round(basePrice * bhkMultiplier * finishMultiplier * 1.2);

  // Format prices
  const formatPrice = (price) => {
    if (price >= 100000) {
      return `₹${(price / 100000).toFixed(1)}L`;
    }
    return `₹${(price / 1000).toFixed(0)}K`;
  };

  // Update display
  document.getElementById('estimate-range').textContent = `${formatPrice(minPrice)} - ${formatPrice(maxPrice)}`;

  // Update summary
  const bhkLabels = { '1bhk': '1 BHK', '2bhk': '2 BHK', '3bhk': '3 BHK', '4bhk': '4+ BHK' };
  const finishLabels = { essential: 'Essential', premium: 'Premium', luxe: 'Luxe' };

  const roomNames = rooms.map(r => estimatorPricing.rooms[r]?.name || r).join(', ');

  document.getElementById('estimate-summary').innerHTML = `
    <div class="summary-item">
      ${icons.home}
      <span>${bhkLabels[bhk]}</span>
    </div>
    <div class="summary-item">
      ${icons.packages}
      <span>${roomNames}</span>
    </div>
    <div class="summary-item">
      ${icons.sparkles}
      <span>${finishLabels[finish]} Finish</span>
    </div>
  `;
}
